import React, { useState } from 'react';

const CutePetStories = () => {
  const [stories, setStories] = useState([
    {
      id: 1,
      title: "小花的冒险",
      author: "猫咪爱好者",
      date: "2025-04-20",
      content: "小花是一只活泼好动的三花猫，她总是喜欢在家里探索各种角落。有一天，她发现了一个神秘的纸箱，钻进去后竟然睡了整整一天！当我们焦急地寻找她时，她只是伸了个懒腰，一脸无辜地看着我们，仿佛在说：'你们在找什么呀？'",
      likes: 156,
      comments: 24,
      image: "https://images.unsplash.com/photo-1573865526739-10659fec78a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2F0fGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60"
    },
    {
      id: 2,
      title: "毛球与窗帘的战争",
      author: "猫爸爸",
      date: "2025-04-15",
      content: "毛球是我家的一只英短蓝猫，他有一个宿敌——客厅的窗帘。每天早上，他都会偷偷潜伏在沙发后面，等待窗帘被风吹动的那一刻，然后猛地扑上去，仿佛在捕捉一个看不见的敌人。这场'战争'已经持续了两年，而窗帘已经被换了三次...",
      likes: 203,
      comments: 31,
      image: "https://images.unsplash.com/photo-1533738363-b7f9aef128ce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Y2F0fGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60"
    },
    {
      id: 3,
      title: "豆豆的午后时光",
      author: "猫咪摄影师",
      date: "2025-04-10",
      content: "豆豆是一只慵懒的橘猫，他最喜欢的事情就是在阳光充足的午后，找一块阳光洒落的地方，舒展自己的身体，享受温暖的阳光浴。有时候，他会一动不动地躺上几个小时，仿佛时间在他身边静止了一般。这些珍贵的时刻，总是让我忍不住拿起相机记录下来。",
      likes: 178,
      comments: 19,
      image: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0fGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60"
    },
    {
      id: 4,
      title: "小黑与鱼缸的故事",
      author: "鱼猫共处",
      date: "2025-04-05",
      content: "小黑是一只好奇心旺盛的黑猫，家里的鱼缸对他来说就像一台永不停息的电视。每天，他都会趴在鱼缸旁边，目不转睛地盯着里面的鱼儿游来游去。有时候，他会用爪子轻轻拍打鱼缸，似乎想要和鱼儿们打招呼。虽然我们担心他会把鱼缸打翻，但他总是很小心，从来没有发生过意外。",
      likes: 142,
      comments: 17,
      image: "https://images.unsplash.com/photo-1511044568932-338cba0ad803?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fGNhdHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60"
    },
    {
      id: 5,
      title: "咪咪的第一次看雪",
      author: "北方猫主",
      date: "2025-03-28",
      content: "咪咪是一只生长在南方的暹罗猫，从来没有见过雪。去年冬天，我们带她去北方探亲，恰好遇到了一场大雪。当她第一次看到窗外飘落的雪花时，整个猫都惊呆了！她小心翼翼地靠近窗户，用爪子轻轻触碰玻璃，然后又迅速缩回来，仿佛被雪花的寒气吓到了。最后，她鼓起勇气，跳到窗台上，整整一个下午都在那里观察着这个对她来说全新的世界。",
      likes: 231,
      comments: 42,
      image: "https://images.unsplash.com/photo-1592194996308-7b43878e84a6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8Y2F0fGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60"
    }
  ]);

  const [activeTab, setActiveTab] = useState('all');
  const [likedStories, setLikedStories] = useState({});

  const handleLike = (id) => {
    if (likedStories[id]) {
      // Unlike
      setStories(stories.map(story => 
        story.id === id ? {...story, likes: story.likes - 1} : story
      ));
      setLikedStories({...likedStories, [id]: false});
    } else {
      // Like
      setStories(stories.map(story => 
        story.id === id ? {...story, likes: story.likes + 1} : story
      ));
      setLikedStories({...likedStories, [id]: true});
    }
  };

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-gradient py-5" style={{ background: 'linear-gradient(to right, #9c27b0, #e91e63)' }}>
        <div className="container">
          <h1 className="display-4 fw-bold text-white text-center">萌宠趣闻</h1>
          <p className="lead text-white text-center">分享您与爱宠之间的温馨故事和难忘瞬间</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-4">
        {/* Tabs */}
        <div className="d-flex justify-content-center mb-4">
          <div className="btn-group shadow-sm" role="group">
            <button 
              type="button" 
              className={`btn ${activeTab === 'all' ? 'btn-primary' : 'btn-light'}`}
              onClick={() => setActiveTab('all')}
            >
              全部故事
            </button>
            <button 
              type="button" 
              className={`btn ${activeTab === 'popular' ? 'btn-primary' : 'btn-light'}`}
              onClick={() => setActiveTab('popular')}
            >
              热门故事
            </button>
            <button 
              type="button" 
              className={`btn ${activeTab === 'latest' ? 'btn-primary' : 'btn-light'}`}
              onClick={() => setActiveTab('latest')}
            >
              最新故事
            </button>
          </div>
        </div>

        {/* Create Story Button */}
        <div className="d-flex justify-content-end mb-3">
          <button className="btn btn-danger rounded-pill shadow-sm d-flex align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus me-2" viewBox="0 0 16 16">
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg>
            分享我的故事
          </button>
        </div>

        {/* Stories Grid */}
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          {stories.map(story => (
            <div key={story.id} className="col">
              <div className="card h-100 shadow-sm rounded-3 border-0 hover-shadow">
                <div style={{ height: '200px', overflow: 'hidden' }}>
                  <img className="card-img-top img-fluid h-100 object-fit-cover" src={story.image} alt={story.title} />
                </div>
                <div className="card-body">
                  <h5 className="card-title fw-bold">{story.title}</h5>
                  <div className="d-flex align-items-center text-muted mb-2 small">
                    <span>{story.author}</span>
                    <span className="mx-2">•</span>
                    <span>{story.date}</span>
                  </div>
                  <p className="card-text text-secondary mb-3" style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}>
                    {story.content}
                  </p>
                  <div className="d-flex justify-content-between align-items-center">
                    <button 
                      className="btn btn-sm btn-link text-decoration-none text-secondary"
                      onClick={() => handleLike(story.id)}
                    >
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="16" 
                        height="16" 
                        fill={likedStories[story.id] ? "currentColor" : "none"}
                        stroke="currentColor"
                        strokeWidth={likedStories[story.id] ? "0" : "1.5"}
                        className="bi bi-heart me-1" 
                        viewBox="0 0 16 16"
                      >
                        <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"/>
                      </svg>
                      {story.likes}
                    </button>
                    <button className="btn btn-sm btn-link text-decoration-none text-secondary">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-share me-1" viewBox="0 0 16 16">
                        <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"/>
                      </svg>
                      分享
                    </button>
                    <button className="btn btn-sm btn-link text-decoration-none text-secondary">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-book me-1" viewBox="0 0 16 16">
                        <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"/>
                      </svg>
                      阅读全文
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        <div className="d-flex justify-content-center mt-5">
          <button className="btn btn-outline-primary rounded-pill px-4">
            加载更多故事
          </button>
        </div>
      </div>

      {/* Newsletter Section */}
      <div className="py-5 mt-5" style={{ background: 'linear-gradient(to right, #e91e63, #9c27b0)' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 text-center">
              <h2 className="display-6 fw-bold text-white">订阅萌宠故事精选</h2>
              <p className="lead text-white opacity-75">每周收到精选萌宠故事，不错过任何温馨瞬间</p>
              <div className="mt-4">
                <div className="input-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="您的邮箱地址"
                  />
                  <button
                    type="button"
                    className="btn btn-primary"
                  >
                    订阅
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CutePetStories;
